import {
    Championships, CompanyAlerts,
    CompanyLogs,
    Drafts,
    Events, Facilities, FeudItems,
    Games,
    GimmickMatches, Messages, Negotiations,
    NewsItems,
    Objectives, Powerups, RandomEvents, Relationships,
    Rosters, SegmentItems, StaffMembers, StoryChoices, TalentRequests, Tournaments, TradeOffers
} from "./models.js";

function Company() {

    // Strings
    const name = null;
    const style = 'entertainment';
    const ownerName = null;
    const weeklyShowName = null;
    const operatingStatus = 'Active';
    const playerName = null;
    const turnStatus = null;
    const activeEffect = null;
    const storyName = null;

    // Integer
    const fans = 3000;
    const points = 150;
    const reputation = null;
    const highestReputation = null;
    const xp = null;
    const realYear = null;
    const overness = 45;
    const month = null;
    const year = null;

    // Boolean
    const ownerAdded = false;
    const standardGimmickMatches = false;
    const hot = false;
    const stale = false;
    const trainingTransferRun = false;
    const trainingCallupRun = false;
    const yearlyReviewRun = false;
    const yearlyCheckRun = false;
    const introducedPowerups = false;
    const userControlled = false;
    const newUserCompany = false;

    // Objects
    const specialFinishesData = {};
    const settings = {};
    const newCompanyData = {};

    // Foreign keys
    const gameId = null;
    const draftId = null;

    return {
        name,
        style,
        ownerName,
        weeklyShowName,
        operatingStatus,
        playerName,
        turnStatus,
        activeEffect,
        storyName,
        fans,
        points,
        reputation,
        highestReputation,
        xp,
        realYear,
        overness,
        month,
        year,
        ownerAdded,
        standardGimmickMatches,
        hot,
        stale,
        trainingTransferRun,
        trainingCallupRun,
        yearlyReviewRun,
        yearlyCheckRun,
        introducedPowerups,
        userControlled,
        newUserCompany,
        specialFinishesData,
        settings,
        gameId,
        draftId,
        newCompanyData
    };
}

function getCompanyRosters(company) {
    return Rosters.find({'companyId': company.$loki});
}

function addCompanyRosters(company, rosters) {
    rosters.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyRosters(company, rosters) {
    rosters.forEach(c => {
        c.companyId = null
    });
}

function getCompanyChampionships(company, filterRetired = true) {
    let companyChampionships = Championships.find({'companyId': company.$loki});
    if (filterRetired) {
        companyChampionships = companyChampionships.filter(x => !x.retired);
    }
    return companyChampionships;
}

function addCompanyChampionships(company, championships) {
    championships.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyChampionships(company, championships) {
    championships.forEach(c => {
        c.companyId = null
    });
}

function addCompanyEvents(company, events) {
    events.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyEvents(company, events) {
    events.forEach(c => {
        c.companyId = null
    });
}

function getCompanyEvents(company) {
    if (!company.gameId) {
        return;
    }
    return Events.find({'companyId': company.$loki});
}

function addCompanyCompanyLogs(company, companyLogs) {
    companyLogs.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyCompanyLogs(company, companyLogs) {
    companyLogs.forEach(c => {
        c.companyId = null
    });
}

function getCompanyCompanyLogs(company) {
    if (!company.gameId) {
        return;
    }
    return CompanyLogs.find({'companyId': company.$loki});
}

function addCompanyGimmickMatches(company, gimmickMatches) {
    gimmickMatches.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyGimmickMatches(company, gimmickMatches) {
    gimmickMatches.forEach(c => {
        c.companyId = null
    });
}

function getCompanyGimmickMatches(company) {
    if (!company.gameId) {
        return;
    }
    return GimmickMatches.find({'companyId': company.$loki});
}

function getCompanyGame(company) {
    return Games.find({'$loki': company.gameId})[0];
}

function addCompanyObjectives(company, objectives) {
    objectives.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyObjectives(company, objectives) {
    objectives.forEach(c => {
        c.companyId = null
    });
}

function getCompanyObjectives(company) {
    if (!company.gameId) {
        return;
    }
    return Objectives.find({'companyId': company.$loki});
}

function addCompanyNewsItems(company, newsItems) {
    newsItems.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyNewsItems(company, newsItems) {
    newsItems.forEach(c => {
        c.companyId = null
    });
}

function getCompanyNewsItems(company) {
    if (!company.gameId) {
        return;
    }
    return NewsItems.find({'companyId': company.$loki});
}

function addCompanyRelationships(company, relationships) {
    relationships.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyRelationships(company, relationships) {
    relationships.forEach(c => {
        c.companyId = null
    });
}

function getCompanyRelationships(company) {
    if (!company.gameId) {
        return;
    }
    return Relationships.find({'companyId': company.$loki});
}

function addCompanyPowerups(company, powerups) {
    powerups.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyPowerups(company, powerups) {
    powerups.forEach(c => {
        c.companyId = null
    });
}

function getCompanyPowerups(company) {
    if (!company.gameId) {
        return;
    }
    return Powerups.find({'companyId': company.$loki});
}

function addCompanyStoryChoices(company, storyChoices) {
    storyChoices.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyStoryChoices(company, storyChoices) {
    storyChoices.forEach(c => {
        c.companyId = null
    });
}

function getCompanyStoryChoices(company) {
    if (!company.gameId) {
        return;
    }
    return StoryChoices.find({'companyId': company.$loki});
}

function addCompanyTournaments(company, tournaments) {
    tournaments.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyTournaments(company, tournaments) {
    tournaments.forEach(c => {
        c.companyId = null
    });
}

function getCompanyTournaments(company) {
    if (!company.gameId) {
        return;
    }
    return Tournaments.find({'companyId': company.$loki});
}

function addCompanyFeudItems(company, feudItems) {
    feudItems.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyFeudItems(company, feudItems) {
    feudItems.forEach(c => {
        c.companyId = null
    });
}

function getCompanyFeudItems(company) {
    if (!company.gameId) {
        return;
    }
    return FeudItems.find({'companyId': company.$loki});
}

function addCompanySegmentItems(company, segmentItems) {
    segmentItems.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanySegmentItems(company, segmentItems) {
    segmentItems.forEach(c => {
        c.companyId = null
    });
}

function getCompanySegmentItems(company) {
    if (!company.gameId) {
        return;
    }
    return SegmentItems.find({'companyId': company.$loki});
}

function addCompanyMessages(company, messages) {
    messages.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyMessages(company, messages) {
    messages.forEach(c => {
        c.companyId = null
    });
}

function getCompanyMessages(company) {
    if (!company.gameId) {
        return;
    }
    return Messages.find({'companyId': company.$loki});
}

function addCompanyRandomEvents(company, randomEvents) {
    randomEvents.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyRandomEvents(company, randomEvents) {
    randomEvents.forEach(c => {
        c.companyId = null
    });
}

function getCompanyRandomEvents(company) {
    if (!company.gameId) {
        return;
    }
    return RandomEvents.find({'companyId': company.$loki});
}

function addCompanyStaff(company, staff) {
    staff.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyStaff(company, staff) {
    staff.forEach(c => {
        c.companyId = null
    });
}

function getCompanyStaff(company) {
    if (!company.gameId) {
        return;
    }
    return StaffMembers.find({'companyId': company.$loki});
}

function addCompanyFacilities(company, facilities) {
    facilities.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyFacilities(company, facilities) {
    facilities.forEach(c => {
        c.companyId = null
    });
}

function getCompanyFacilities(company) {
    if (!company.gameId) {
        return;
    }
    return Facilities.find({'companyId': company.$loki});
}

function addCompanyCompanyAlerts(company, companyAlerts) {
    companyAlerts.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyCompanyAlerts(company, companyAlerts) {
    companyAlerts.forEach(c => {
        c.companyId = null
    });
}

function getCompanyCompanyAlerts(company) {
    if (!company.gameId) {
        return;
    }
    return CompanyAlerts.find({'companyId': company.$loki});
}

function getCompanyDraft(company) {
    return Drafts.find({'$loki': company.draftId})[0];
}

function addCompanySentNegotiations(company, negotiations) {
    negotiations.forEach(c => {
        c.senderCompanyId = company.$loki
    });
}

function removeCompanySentNegotiations(company, negotiations) {
    negotiations.forEach(c => {
        c.senderCompanyId = null
    });
}

function getCompanySentNegotiations(company) {
    if (!company.gameId) {
        return;
    }
    return Negotiations.find({'senderCompanyId': company.$loki});
}

function addCompanyReceivedNegotiations(company, negotiations) {
    negotiations.forEach(c => {
        c.receiverCompanyId = company.$loki
    });
}

function removeCompanyReceivedNegotiations(company, negotiations) {
    negotiations.forEach(c => {
        c.receiverCompanyId = null
    });
}

function getCompanyReceivedNegotiations(company) {
    if (!company.gameId) {
        return;
    }
    return Negotiations.find({'receiverCompanyId': company.$loki});
}

function addCompanySentTradeOffers(company, tradeOffers) {
    tradeOffers.forEach(c => {
        c.senderCompanyId = company.$loki
    });
}

function removeCompanySentTradeOffers(company, tradeOffers) {
    tradeOffers.forEach(c => {
        c.senderCompanyId = null
    });
}

function getCompanySentTradeOffers(company) {
    if (!company.gameId) {
        return;
    }
    return TradeOffers.find({'senderCompanyId': company.$loki});
}

function addCompanyReceivedTradeOffers(company, tradeOffers) {
    tradeOffers.forEach(c => {
        c.receiverCompanyId = company.$loki
    });
}

function removeCompanyReceivedTradeOffers(company, tradeOffers) {
    tradeOffers.forEach(c => {
        c.receiverCompanyId = null
    });
}

function getCompanyReceivedTradeOffers(company) {
    if (!company.gameId) {
        return;
    }
    return TradeOffers.find({'receiverCompanyId': company.$loki});
}

function addCompanyTalentRequests(company, talentRequests) {
    talentRequests.forEach(c => {
        c.companyId = company.$loki
    });
}

function removeCompanyTalentRequests(company, talentRequests) {
    talentRequests.forEach(c => {
        c.companyId = null
    });
}

function getCompanyTalentRequests(company) {
    if (!company.gameId) {
        return;
    }
    return TalentRequests.find({'companyId': company.$loki});
}

export { Company, getCompanyRosters, addCompanyRosters, removeCompanyRosters, getCompanyChampionships,
    addCompanyChampionships, removeCompanyChampionships, addCompanyEvents, removeCompanyEvents, getCompanyEvents,
    getCompanyGame, addCompanyCompanyLogs, removeCompanyCompanyLogs, getCompanyCompanyLogs, addCompanyGimmickMatches,
    removeCompanyGimmickMatches, getCompanyGimmickMatches, addCompanyObjectives, removeCompanyObjectives,
    getCompanyObjectives, addCompanyNewsItems, removeCompanyNewsItems, getCompanyNewsItems, addCompanyRelationships,
    removeCompanyRelationships, getCompanyRelationships, addCompanyPowerups, removeCompanyPowerups,
    getCompanyPowerups, addCompanyStoryChoices, removeCompanyStoryChoices, getCompanyStoryChoices,
    addCompanyTournaments, removeCompanyTournaments, getCompanyTournaments, addCompanyFeudItems,
    removeCompanyFeudItems, getCompanyFeudItems, addCompanySegmentItems, removeCompanySegmentItems,
    getCompanySegmentItems, addCompanyMessages, removeCompanyMessages, getCompanyMessages, addCompanyRandomEvents,
    removeCompanyRandomEvents, getCompanyRandomEvents, addCompanyStaff, removeCompanyStaff, getCompanyStaff,
    addCompanyFacilities, removeCompanyFacilities, getCompanyFacilities, addCompanyCompanyAlerts,
    removeCompanyCompanyAlerts, getCompanyCompanyAlerts, getCompanyDraft, addCompanyReceivedNegotiations,
    removeCompanyReceivedNegotiations, getCompanyReceivedNegotiations, addCompanySentNegotiations,
    removeCompanySentNegotiations, getCompanySentNegotiations, addCompanyReceivedTradeOffers,
    addCompanySentTradeOffers, removeCompanyReceivedTradeOffers, removeCompanySentTradeOffers,
    getCompanyReceivedTradeOffers, getCompanySentTradeOffers, addCompanyTalentRequests, removeCompanyTalentRequests,
    getCompanyTalentRequests };